import { extend, $$ } from './HelperFunctions'

export class Dropdown {
  constructor (selectors, classes) {
    this.selectors = extend({
      dropdown: '[data-js-dropdown-toggle]'
    }, selectors)

    this.classes = extend({
      active: 'is--active'
    }, classes)
  }

  init () {
    this.addDropdownEvent()
  }

  addDropdownEvent () {
    const that = this
    const dropdowns = $$(that.selectors.dropdown)

    if (dropdowns) {
      [].forEach.call(dropdowns, (dropdown) => {
        const dropdownControls = dropdown.getAttribute('aria-controls')
        const dropdownContent = dropdown.parentNode.querySelector(`#${dropdownControls}`)

        if (dropdownContent) {
          dropdown.addEventListener('click', function (event) {
            event.preventDefault()

            if (dropdownContent.classList.contains(that.classes.active)) {
              closeDropdown(dropdownContent, dropdown)
            } else {
              dropdownContent.classList.add(that.classes.active)
              dropdownContent.removeAttribute('hidden')
              dropdown.setAttribute('aria-expanded', 'true')
            }

            document.addEventListener('click', function (event) {
              if (event.target !== dropdown && event.target !== dropdownContent) {
                closeDropdown(dropdownContent, dropdown)
              }
            })

            document.addEventListener('keydown', function (event) {
              if (event.key === 'Escape') {
                closeDropdown(dropdownContent, dropdown)
              }
            })
          })
        }
      })

      function closeDropdown (dropdownContent, dropdown) {
        dropdownContent.classList.remove(that.classes.active)
        dropdownContent.setAttribute('hidden', 'hidden')
        dropdown.setAttribute('aria-expanded', 'false')
      }
    }
  }
}

export default Dropdown
